import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { BOX_IMAGE } from '../data/product';
export function FinalCTA() {
  return <section className="bg-navy px-4 py-6 text-white sm:py-8" data-id="element-42" data-mp="c6sk7g2tg6cb">
      <div className="mx-auto max-w-3xl text-center" data-id="element-43" data-mp="c8c0v7sdwjem">
        <h2 className="text-2xl sm:text-4xl" data-id="element-44" data-mp="84nuutjehvvh">ONE LAST QUESTION</h2>
        <p className="mt-2 text-sm font-medium leading-snug text-white/85 sm:text-base" data-id="element-45" data-mp="87jrmejiieic">
          When a vehicle comes in with a fault... Do you immediately know what
          to test first? Stop jumping between possible causes. Open the system.
          Find the symptom. Follow the diagnostic path.
        </p>
        <p className="mt-1.5 font-display text-lg uppercase tracking-wide text-cyan sm:text-2xl" data-id="element-46" data-mp="qvotfgglzpei">
          Scan. Test. Diagnose.
        </p>

        <a href="#offer" className="mt-3 block" data-id="element-47" data-mp="14w7v85uhdz88">
          <img src={BOX_IMAGE} alt="AUTOMOTIVE DIAGNOSTIC PRO™ complete 6-in-1 system" className="mx-auto w-full max-w-[15rem]" loading="lazy" data-id="element-48" data-mp="zwd6a7u9njpt" />
        </a>

        <p className="mt-2 font-display text-2xl uppercase text-white sm:text-3xl" data-id="element-49" data-mp="2h3hruxxwxeal">
          🔧 AUTOMOTIVE DIAGNOSTIC PRO™
        </p>
        <p className="mt-1 font-display text-base uppercase leading-tight tracking-wide text-cyan sm:text-xl" data-id="element-50" data-mp="2m21e6zgf4s3h">
          The Complete Visual Fault-Finding System For Automotive Technicians
        </p>
        <p className="mt-1 font-mono text-[11px] uppercase tracking-wider text-white/70" data-id="element-51" data-mp="2v2r1ferm5a5l">
          Workflow • Engine • Electrical • OBD-II • Symptoms • Networks
        </p>

        <p className="mt-3 font-display text-xl uppercase text-white sm:text-2xl" data-id="element-52" data-mp="34t2a1em8s7it">
          🔥 GET THE COMPLETE SYSTEM TODAY
        </p>
        <div className="mt-2 flex justify-center" data-id="element-53" data-mp="39rn9hbto6n67">
          <CTAButton href="#offer" data-id="element-54" data-mp="3es1hitv9tx48">🔧 GET AUTOMOTIVE DIAGNOSTIC PRO™</CTAButton>
        </div>
        <p className="mt-2 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-[11px] font-semibold uppercase tracking-wide text-white/75" data-id="element-55" data-mp="3islg81vht8sh">
          <span data-id="element-56" data-mp="1jola43m3416o">Immediate Access • Digital Delivery</span>
          <span className="flex items-center gap-1.5" data-id="element-57" data-mp="1eq1ok4bekreu">
            <ShieldCheckIcon className="h-4 w-4 text-cyan" aria-hidden="true" data-id="element-58" data-mp="1enfhe5sfcdx5" />
            7-Day Money-Back Guarantee
          </span>
        </p>
      </div>
    </section>;
}